// extracted by mini-css-extract-plugin
var _1 = "ChatroomMessagesSkeleton-moduleavatar__yW0hl Skeleton-moduleSkeleton__Mlrfv";
var _2 = "ChatroomMessagesSkeleton-modulechatroomMessagesSkeleton__MJrdg";
var _3 = "ChatroomMessagesSkeleton-moduleheader__pq5Ws";
var _4 = "ChatroomMessagesSkeleton-moduleitem__i0zw4";
var _5 = "ChatroomMessagesSkeleton-moduleitemOwn__eiv3y";
var _6 = "ChatroomMessagesSkeleton-modulemessageBody__rj_3H Skeleton-moduleSkeleton__Mlrfv";
var _7 = "ChatroomMessagesSkeleton-modulemessageBodyOwn__lm1_v Skeleton-moduleSkeleton__Mlrfv";
var _8 = "ChatroomMessagesSkeleton-modulename__SP7wF Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "avatar", _2 as "chatroomMessagesSkeleton", _3 as "header", _4 as "item", _5 as "itemOwn", _6 as "messageBody", _7 as "messageBodyOwn", _8 as "name" }
